export const UPDATE_ACTIVE_DURATION = "UPDATE_ACTIVE_DURATION";
export const UPDATE_PRODUCT_SORTING = "UPDATE_PRODUCT_SORTING";
export const UPDATE_DASHBOARD_STATE = "UPDATE_DASHBOARD_STATE";
export const UPDATE_GUIDE_MODAL = "UPDATE_GUIDE_MODAL";
export const UPDATE_CUSTOM_DATE = "UPDATE_CUSTOM_DATE";
export const UPDATE_METRICS_DATA = "UPDATE_METRICS_DATA";
export const UPDATE_VIDEO_DATA = "UPDATE_VIDEO_DATA";
export const UPDATE_PRODUCT_DATA = "UPDATE_PRODUCT_DATA";
export const UPDATE_SELECTED_CAROUSEL = "UPDATE_SELECTED_CAROUSEL";
export const UPDATE_SELECTED_DEVICE = "UPDATE_SELECTED_DEVICE";
import axios from "axios";

export const selectedDeviceAction = (selectedDevice) => ({
  type: UPDATE_SELECTED_DEVICE,
  selectedDevice,
});

export const selectedCarouselAction = (carousel) => ({
  type: UPDATE_SELECTED_CAROUSEL,
  selectedCarousel: carousel,
});

export const updateMetricsData = (metricsData) => ({
  type: UPDATE_METRICS_DATA,
  metricsData,
});

export const updateVideoData = (fetchedVideoData) => ({
  type: UPDATE_VIDEO_DATA,
  fetchedVideoData,
});

export const updateProductData = (fetchedProductData) => ({
  type: UPDATE_PRODUCT_DATA,
  fetchedProductData,
});

export const updateActiveDuration = (selectedDuration) => ({
  type: UPDATE_ACTIVE_DURATION,
  selectedDuration,
});

export const updateActiveSorting = (productsSortBy) => ({
  type: UPDATE_PRODUCT_SORTING,
  productsSortBy,
});

export const updateDashboardState = (data) => ({
  type: UPDATE_DASHBOARD_STATE,
  data,
});

export const updateModalState = (userGuideModal) => ({
  type: UPDATE_GUIDE_MODAL,
  userGuideModal,
});

export const updateCustomDate = (customDate) => ({
  type: UPDATE_CUSTOM_DATE,
  customDate,
});

const apiUrl = process.env.REACT_APP_WIDGET_BASE_URL;
const apiKey =
  "ZhrsS5EtnaA1shtKyC6Tr3IOS5M1rQcRPjxyAk7jhndlNOlJbwUleGH0vEeEU4eb";

const getConfig = (method, data = null) => ({
  method,
  url: `${apiUrl}${method === "get"}`,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": apiKey,
  },
  data,
  maxBodyLength: Infinity,
});

export const getMetricsData = async (params) => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/metrics?${params}`,
      getConfig("get")
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
